module.exports = __webpack_public_path__ + "img/info_sp_09.4ad6b767.png";